import * as React from "react"
export const IconExpandClose = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={fill} fillRule="evenodd" clipRule="evenodd" d="M10.233 7.206a.698.698 0 0 0 0 .989l4.01 4c.274.273.72.274.993-.001l4.013-3.998a.696.696 0 0 0 0-.99.704.704 0 0 0-.992.002l-3.515 3.502-3.517-3.505a.701.701 0 0 0-.992.001zm0 15.988a.698.698 0 0 1 0-.989l4.01-4a.702.702 0 0 1 .993 0l4.013 3.998a.696.696 0 0 1 0 .99.704.704 0 0 1-.992-.002l-3.515-3.502-3.517 3.505a.701.701 0 0 1-.992 0z" />
    </svg>
}
export default IconExpandClose;